import { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're subscribed! Cosmic insights incoming ✨");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="relative z-10 bg-primary text-primary-foreground mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10">
                <Sparkles className="h-4 w-4 text-gold" strokeWidth={1.6} />
              </span>
              <span className="font-serif text-3xl tracking-tight">Numoraa</span>
            </div>
            <p className="mt-5 max-w-sm text-sm text-primary-foreground/70 leading-relaxed">
              India's AI-powered numerology platform. Warm, insightful guidance drawn from your name and birth numbers — for reflection, never guarantees.
            </p>
            <form onSubmit={subscribe} className="mt-8" data-testid="footer-newsletter">
              <label className="text-xs uppercase tracking-[0.2em] text-gold">Newsletter</label>
              <div className="mt-3 flex items-center gap-2 border-b border-white/25 pb-2">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className="flex-1 bg-transparent text-sm outline-none placeholder:text-primary-foreground/40"
                  data-testid="newsletter-email-input"
                />
                <button
                  disabled={loading}
                  className="text-sm text-gold hover:translate-x-1 transition-transform"
                  data-testid="newsletter-submit"
                >
                  {loading ? "…" : "Subscribe →"}
                </button>
              </div>
            </form>
          </div>

          <div className="md:col-span-2 md:col-start-7">
            <h4 className="text-xs uppercase tracking-[0.2em] text-gold">Tools</h4>
            <ul className="mt-5 space-y-3 text-sm text-primary-foreground/70">
              <li><Link to="/tools/numerology-calculator" className="hover:text-white">Numerology Calculator</Link></li>
              <li><Link to="/tools/palm-reading" className="hover:text-white">AI Palm Reading</Link></li>
              <li><Link to="/tools/lo-shu-grid" className="hover:text-white">Lo Shu Grid</Link></li>
              <li><Link to="/tools/love-calculator" className="hover:text-white">Love Calculator</Link></li>
              <li><Link to="/tools/numerology-report" className="hover:text-white">Personalized Report</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-gold">Explore</h4>
            <ul className="mt-5 space-y-3 text-sm text-primary-foreground/70">
              <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
              <li><Link to="/chat" className="hover:text-white">AI Pandit Chat</Link></li>
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-gold">Legal</h4>
            <ul className="mt-5 space-y-3 text-sm text-primary-foreground/70">
              <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white">Terms & Conditions</Link></li>
              <li><Link to="/disclaimer" className="hover:text-white">Disclaimer</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-primary-foreground/50">
          <p>© {new Date().getFullYear()} Numoraa. All rights reserved.</p>
          <p>For entertainment & self-reflection purposes only.</p>
        </div>
      </div>
    </footer>
  );
}
